/**
 * Product video slider — centered fan carousel + custom video popup.
 */
(function () {
  if (window.__gbPvsScriptBound) return;
  window.__gbPvsScriptBound = true;

  var MODAL_TRANSITION_MS = 380;

  function parseGallery(root) {
    var node = root.querySelector('[data-gb-pvs-gallery]');
    if (!node) return [];
    try {
      var data = JSON.parse(node.textContent);
      return Array.isArray(data) ? data : [];
    } catch (error) {
      return [];
    }
  }

  function isMobileFan() {
    return window.matchMedia('(max-width: 767px)').matches;
  }

  function isModalMobile() {
    return window.matchMedia('(max-width: 767px)').matches;
  }

  function getFanConfig(root, videoCount) {
    var width = window.innerWidth;
    var perView;
    if (width <= 767) {
      perView = parseInt(root.getAttribute('data-visible-slides-mobile'), 10) || 3;
    } else if (width <= 989) {
      perView = parseInt(root.getAttribute('data-visible-slides-tablet'), 10) || 5;
    } else {
      perView = parseInt(root.getAttribute('data-visible-slides'), 10) || 5;
    }
    var mobile = width <= 767;
    var sideSlides = Math.max(1, Math.floor(perView / 2));

    if (mobile && videoCount > 0 && videoCount <= perView) {
      sideSlides = Math.max(sideSlides, videoCount - 1);
    }

    return {
      perView: perView,
      sideSlides: sideSlides,
      gapRatio: mobile ? 0.3 : 0.44,
      scaleStep: mobile ? 0.1 : 0.18,
      opacityStep: mobile ? 0.12 : 0.16,
      blurStep: mobile ? 2.4 : 3.2
    };
  }

  function getSlides(el) {
    return Array.prototype.slice.call(el.querySelectorAll('.swiper-wrapper > .swiper-slide'));
  }

  function applyCardPoster(card) {
    if (!card || !card.dataset.gbPvsPoster) return;
    card.style.backgroundImage = 'url("' + card.dataset.gbPvsPoster + '")';
  }

  function inlineVideoHasSrc(video) {
    if (!video) return false;
    if (video.currentSrc) return true;
    if (video.getAttribute('src')) return true;
    var sources = video.querySelectorAll('source');
    for (var i = 0; i < sources.length; i += 1) {
      if (sources[i].getAttribute('src')) return true;
    }
    return false;
  }

  function slideLogicalIndex(slide, state) {
    var idx = parseInt(slide.getAttribute('data-gb-pvs-index'), 10);
    if (!isNaN(idx)) return idx;
    if (!state || !state.slides || !state.count) return 0;
    var domIdx = state.slides.indexOf(slide);
    if (domIdx < 0) return 0;
    return logicalIndex({ index: domIdx, count: state.count });
  }

  function resolveInlineVideoUrl(slide, state) {
    var card = slide.querySelector('.gb-pvs__card');
    var fromCard = card && card.getAttribute('data-src');
    var logical = slideLogicalIndex(slide, state);
    var fromGallery =
      state && state.gallery && state.gallery[logical] ? state.gallery[logical].src : '';
    return fromGallery || fromCard || '';
  }

  // Hux: Kann der Browser HLS nativ (iOS Safari, Android Chrome), nutzen wir den adaptiven Stream.
  // Der startet mit kleiner Auflösung und wird nur bei guter Verbindung besser – statt immer 1080p.
  var hlsSupport = null;
  function canPlayHls() {
    if (hlsSupport === null) {
      try {
        var probe = document.createElement('video');
        hlsSupport = !!(probe.canPlayType && probe.canPlayType('application/vnd.apple.mpegurl'));
      } catch (error) {
        hlsSupport = false;
      }
    }
    return hlsSupport;
  }

  // Hux: Shopify listet im HLS-Master 1080p zuerst – Safari startet dann immer mit 1080p
  // (ca. 4 MB pro 3-Sekunden-Segment). Wir lesen die Master-Liste einmal aus und spielen gezielt
  // eine passende Variante: Vorschau 480p, Popup 720p (bei langsamer Verbindung 480p).
  var hlsVariantCache = {};

  function loadHlsVariants(masterUrl) {
    if (!masterUrl) return null;
    if (hlsVariantCache[masterUrl]) return hlsVariantCache[masterUrl];
    var entry = { ready: false, variants: [] };
    hlsVariantCache[masterUrl] = entry;
    try {
      entry.promise = fetch(masterUrl, { credentials: 'omit' })
        .then(function (res) {
          return res.ok ? res.text() : '';
        })
        .then(function (text) {
          var lines = (text || '').split(/\r?\n/);
          for (var i = 0; i < lines.length; i += 1) {
            var m = /RESOLUTION=(\d+)x(\d+)/.exec(lines[i]);
            if (!m || lines[i].indexOf('#EXT-X-STREAM-INF') !== 0) continue;
            var uri = (lines[i + 1] || '').trim();
            if (!uri || uri.charAt(0) === '#') continue;
            entry.variants.push({
              // "480p/720p" bezieht sich bei Hochformat-Videos auf die lange Seite
              short: Math.max(parseInt(m[1], 10), parseInt(m[2], 10)),
              url: new URL(uri, new URL(masterUrl, window.location.href)).toString()
            });
          }
          entry.variants.sort(function (a, b) {
            return a.short - b.short;
          });
          entry.ready = true;
          return entry;
        })
        .catch(function () {
          entry.ready = true;
          return entry;
        });
    } catch (error) {
      entry.ready = true;
    }
    return entry;
  }

  function isSlowConnection() {
    try {
      var c = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      if (!c) return false;
      if (c.saveData) return true;
      if (c.effectiveType && c.effectiveType !== '4g') return true;
      if (typeof c.downlink === 'number' && c.downlink > 0 && c.downlink < 6) return true;
    } catch (error) {
      /* ignore */
    }
    return false;
  }

  // Liefert die Variante mit kurzer Seite >= minShort (kleinste passende), sonst die grösste kleinere.
  function pickHlsUrl(masterUrl, minShort) {
    if (!masterUrl) return '';
    var entry = loadHlsVariants(masterUrl);
    if (!entry || !entry.ready || !entry.variants.length) return masterUrl;
    var best = null;
    for (var i = 0; i < entry.variants.length; i += 1) {
      if (entry.variants[i].short >= minShort) {
        best = entry.variants[i];
        break;
      }
    }
    if (!best) best = entry.variants[entry.variants.length - 1];
    return best.url;
  }

  function preloadHlsVariants(root) {
    if (!canPlayHls() || !root) return;
    root.querySelectorAll('[data-hls]').forEach(function (el) {
      loadHlsVariants(el.getAttribute('data-hls'));
    });
    var galleryEl = root.querySelector('[data-gb-pvs-gallery]');
    if (galleryEl) {
      try {
        JSON.parse(galleryEl.textContent).forEach(function (item) {
          if (item && item.hls) loadHlsVariants(item.hls);
        });
      } catch (error) {
        /* ignore */
      }
    }
  }

  // Popup: auf dem Handy oder bei langsamer Verbindung 480p – dieselbe Variante wie die Vorschau,
  // deren erste Segmente schon im Browser-Cache liegen, dadurch startet das Popup fast sofort.
  // Auf grossen Bildschirmen mit guter Verbindung 720p.
  function modalHlsMinShort() {
    var small = false;
    try {
      small = window.matchMedia && window.matchMedia('(max-width: 767px)').matches;
    } catch (error) {
      small = false;
    }
    return small || isSlowConnection() ? 480 : 720;
  }

  function applyHlsSource(video) {
    if (!video) return;
    var hls = video.getAttribute('data-hls');
    if (!hls || !canPlayHls()) return;
    var target = pickHlsUrl(hls, 480);
    var current = video.getAttribute('src') || '';
    // nur wechseln, solange das Video noch nicht läuft
    if (current !== target && (video.paused || !current) && video.readyState < 2) {
      video.setAttribute('src', target);
    }
  }

  function applyCanonicalInlineSource(slide, state) {
    var video = slide.querySelector('.gb-pvs__video');
    if (!video) return null;
    applyHlsSource(video);

    if (!inlineVideoHasSrc(video)) {
      var url = resolveInlineVideoUrl(slide, state);
      if (url) video.setAttribute('src', url);
    }

    video.autoplay = false;
    video.removeAttribute('autoplay');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    return video;
  }

  function ensureInlineVideoReady(slide, state) {
    return applyCanonicalInlineSource(slide, state);
  }

  function primeInlineVideoForPlay(video) {
    if (!video) return;
    var prev = video.preload;
    video.preload = 'auto';
    if (prev !== 'auto') {
      try {
        video.load();
      } catch (error) {
        /* ignore */
      }
    }
  }

  // Hux: Bei Datensparmodus, langsamer Verbindung oder reduzierter Bewegung keine
  // automatischen Vorschau-Videos laden – nur Vorschaubilder. Klick öffnet weiterhin das Video.
  function prefersLightVideo() {
    try {
      var c = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      if (c && (c.saveData || /(^|-)(2g|3g)$/.test(c.effectiveType || ''))) return true;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return true;
    } catch (error) {
      /* ignore */
    }
    return false;
  }

  function primeActiveSlideVideo(state) {
    if (!state || !state.slides || !state.slides.length) return;
    // Hux: erst laden, wenn die Section sichtbar ist
    if (state.inView === false || prefersLightVideo()) return;
    var slide = state.slides[state.index];
    if (!slide) return;
    var video = ensureInlineVideoReady(slide, state);
    if (video) primeInlineVideoForPlay(video);
  }

  function prefetchSlideVideo(slide, state) {
    if (!slide) return;
    var video = ensureInlineVideoReady(slide, state);
    if (!video || isVideoActivelyPlaying(video)) return;
    if (video.preload === 'auto' && video.readyState >= 2) return;
    primeInlineVideoForPlay(video);
  }

  function prefetchNeighborPreviewVideos(state) {
    // Hux: Nachbar-Videos werden nicht mehr vorgeladen (spart auf dem Handy mehrere MB pro Video)
    return;
    if (!state || !state.slides || state.slides.length < 2) return;
    var active = state.index;
    var fan = getFanConfig(state.root, state.count);
    var range = Math.max(1, fan.sideSlides);
    for (var d = -range; d <= range; d += 1) {
      if (d === 0) continue;
      var i = active + d;
      if (i < 0 || i >= state.slides.length) continue;
      prefetchSlideVideo(state.slides[i], state);
    }
  }

  function slideDomDistance(activeIndex, slideIndex) {
    return Math.abs(slideIndex - activeIndex);
  }

  function isVideoActivelyPlaying(video) {
    return !!(video && !video.paused && !video.ended);
  }

  function stopVideoPlayback(video) {
    if (!video) return;
    video.pause();
    video.autoplay = false;
    video.removeAttribute('autoplay');
  }

  function releaseVideoElement(video) {
    if (!video) return;
    stopVideoPlayback(video);
    video.muted = true;
    video.controls = false;
    try {
      video.removeAttribute('src');
      video.querySelectorAll('source').forEach(function (source) {
        source.removeAttribute('src');
        source.remove();
      });
      video.load();
    } catch (error) {
      /* ignore */
    }
  }

  function copyVideoMedia(origVideo, cloneVideo) {
    if (!origVideo || !cloneVideo) return;

    var poster = origVideo.getAttribute('poster');
    if (poster) cloneVideo.setAttribute('poster', poster);

    var origSrc = origVideo.getAttribute('src');
    if (origSrc) cloneVideo.setAttribute('src', origSrc);

    var origSources = origVideo.querySelectorAll('source');
    var cloneSources = cloneVideo.querySelectorAll('source');

    if (origSources.length && !cloneSources.length) {
      origSources.forEach(function (source) {
        cloneVideo.appendChild(source.cloneNode(true));
      });
    } else {
      origSources.forEach(function (source, i) {
        if (!cloneSources[i] || !source.getAttribute('src')) return;
        cloneSources[i].setAttribute('src', source.getAttribute('src'));
      });
    }

    if (!inlineVideoHasSrc(cloneVideo)) {
      var card = cloneVideo.closest('.gb-pvs__card') || origVideo.closest('.gb-pvs__card');
      var fallback = card && card.getAttribute('data-src');
      if (fallback) cloneVideo.setAttribute('src', fallback);
    }

  }

  function hydrateSlide(slide, original, state) {
    if (!slide) return;
    applyCardPoster(slide.querySelector('.gb-pvs__card'));
    if (state) ensureInlineVideoReady(slide, state);
    if (original) {
      var origCard = original.querySelector('.gb-pvs__card');
      var cloneCard = slide.querySelector('.gb-pvs__card');
      if (origCard && cloneCard && origCard.dataset.gbPvsPoster) {
        cloneCard.dataset.gbPvsPoster = origCard.dataset.gbPvsPoster;
        applyCardPoster(cloneCard);
      }
      copyVideoMedia(original.querySelector('.gb-pvs__video'), slide.querySelector('.gb-pvs__video'));
    }
    var video = slide.querySelector('.gb-pvs__video');
    if (video) {
      video.autoplay = false;
      video.removeAttribute('autoplay');
    }
  }

  function stripLoopCopies(el) {
    getSlides(el).forEach(function (slide) {
      if (slide.dataset.gbPvsClone === 'true') slide.remove();
    });
  }

  function cloneRealSlide(slide, logicalIndex, state) {
    var clone = slide.cloneNode(true);
    clone.dataset.gbPvsClone = 'true';
    clone.dataset.gbPvsIndex = String(logicalIndex);
    clone.classList.remove('is-active', 'swiper-slide-active');
    hydrateSlide(clone, slide, state);
    return clone;
  }

  function seedSeamlessLoop(el, originals, state) {
    var wrapper = el.querySelector('.swiper-wrapper');
    if (!wrapper || originals.length < 2) return;

    var prepend = document.createDocumentFragment();
    var append = document.createDocumentFragment();

    originals.forEach(function (slide, index) {
      prepend.appendChild(cloneRealSlide(slide, index, state));
      append.appendChild(cloneRealSlide(slide, index, state));
    });

    wrapper.insertBefore(prepend, wrapper.firstChild);
    wrapper.appendChild(append);
  }

  function pauseInlineVideos(root) {
    root.querySelectorAll('.gb-pvs__video').forEach(function (video) {
      stopVideoPlayback(video);
    });
    root.querySelectorAll('.gb-pvs__card').forEach(function (card) {
      card.classList.remove('is-preview-playing');
    });
  }

  function logicalIndex(state) {
    var count = state.count;
    if (!count) return 0;
    return ((state.index % count) + count) % count;
  }

  function circularOffset(slideIndex, activeIndex, count) {
    if (!count) return 0;
    var offset = slideIndex - activeIndex;
    var half = count / 2;
    if (offset > half) offset -= count;
    if (offset < -half) offset += count;
    return offset;
  }

  function syncPreviewPlayingClass(slide, video) {
    if (!slide) return;
    var card = slide.querySelector('.gb-pvs__card');
    var playing = !!(video && !video.paused && !video.ended);
    if (card) card.classList.toggle('is-preview-playing', playing);
  }

  function configureInlinePreviewVideo(video, loop) {
    video.muted = true;
    video.defaultMuted = true;
    video.volume = 0;
    video.setAttribute('muted', '');
    video.loop = loop;
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.autoplay = false;
    video.removeAttribute('autoplay');
  }

  function isPreviewSlideTarget(state, slideIdx, video, gen) {
    return (
      state &&
      !state.destroyed &&
      !state.modalOpen &&
      !state.dragging &&
      state.index === slideIdx &&
      state.previewPlayGen === gen &&
      state.previewVideo === video
    );
  }

  function playInlinePreview(state, slide, video, loop) {
    if (!video) return;
    if (prefersLightVideo()) return;
    applyCanonicalInlineSource(slide, state);
    primeInlineVideoForPlay(video);
    configureInlinePreviewVideo(video, loop);

    var slideIdx = state.slides.indexOf(slide);
    if (slideIdx < 0) return;

    if (isVideoActivelyPlaying(video) && state.previewVideo === video && state.previewSlideIndex === slideIdx) {
      syncPreviewPlayingClass(slide, video);
      return;
    }

    if (state.previewPlayGen == null) state.previewPlayGen = 0;
    var sameSlideTarget =
      state.previewVideo === video && state.previewSlideIndex === slideIdx;
    if (sameSlideTarget && state.previewPlayInFlight) {
      return;
    }

    state.previewPlayGen += 1;
    state.previewPlayInFlight = true;
    var gen = state.previewPlayGen;
    state.previewVideo = video;
    state.previewSlideIndex = slideIdx;

    function endPlayAttempt() {
      clearInViewWaitTimer();
      if (bufferRetryTimer) {
        window.clearTimeout(bufferRetryTimer);
        bufferRetryTimer = null;
      }
      video.removeEventListener('waiting', onBufferingIssue);
      video.removeEventListener('stalled', onBufferingIssue);
      if (state.previewPlayGen === gen && state.previewVideo === video) {
        state.previewPlayInFlight = false;
      }
    }

    var inViewWaitTimer = null;
    function clearInViewWaitTimer() {
      if (inViewWaitTimer) {
        window.clearTimeout(inViewWaitTimer);
        inViewWaitTimer = null;
      }
    }

    function waitForInViewThenAttempt() {
      if (!isPreviewSlideTarget(state, slideIdx, video, gen)) {
        clearInViewWaitTimer();
        endPlayAttempt();
        return;
      }
      if (state.inView !== false) {
        clearInViewWaitTimer();
        attemptPlay();
        return;
      }
      if (inViewWaitTimer) return;
      inViewWaitTimer = window.setTimeout(function () {
        inViewWaitTimer = null;
        waitForInViewThenAttempt();
      }, 200);
    }

    function attemptPlay() {
      if (!isPreviewSlideTarget(state, slideIdx, video, gen)) {
        endPlayAttempt();
        return;
      }
      if (state.inView === false) {
        waitForInViewThenAttempt();
        return;
      }
      configureInlinePreviewVideo(video, loop);
      if (isVideoActivelyPlaying(video)) {
        endPlayAttempt();
        syncPreviewPlayingClass(slide, video);
        return;
      }
      var playPromise;
      try {
        playPromise = video.play();
      } catch (error) {
        scheduleRetry();
        return;
      }
      if (playPromise && typeof playPromise.then === 'function') {
        playPromise
          .then(function () {
            if (!isPreviewSlideTarget(state, slideIdx, video, gen)) {
              stopVideoPlayback(video);
              endPlayAttempt();
              return;
            }
            endPlayAttempt();
            syncPreviewPlayingClass(slide, video);
          })
          .catch(function () {
            scheduleRetry();
          });
      } else {
        endPlayAttempt();
        syncPreviewPlayingClass(slide, video);
      }
    }

    var retries = 0;
    var maxRetries = 4;
    function scheduleRetry() {
      if (!isPreviewSlideTarget(state, slideIdx, video, gen)) {
        endPlayAttempt();
        syncPreviewPlayingClass(slide, video);
        return;
      }
      if (state.inView === false) {
        waitForInViewThenAttempt();
        return;
      }
      if (retries >= maxRetries) {
        endPlayAttempt();
        syncPreviewPlayingClass(slide, video);
        return;
      }
      retries += 1;
      primeInlineVideoForPlay(video);
      window.setTimeout(function () {
        if (!isPreviewSlideTarget(state, slideIdx, video, gen)) {
          endPlayAttempt();
          return;
        }
        if (state.inView === false) {
          waitForInViewThenAttempt();
          return;
        }
        if (video.paused) attemptPlay();
      }, 220 * retries);
    }

    var bufferRetryTimer = null;
    function onBufferingIssue() {
      if (!isPreviewSlideTarget(state, slideIdx, video, gen)) return;
      if (state.inView === false || !video.paused) return;
      if (bufferRetryTimer) return;
      bufferRetryTimer = window.setTimeout(function () {
        bufferRetryTimer = null;
        if (!isPreviewSlideTarget(state, slideIdx, video, gen)) return;
        if (state.inView === false || !video.paused) return;
        attemptPlay();
      }, 320);
    }

    video.addEventListener('waiting', onBufferingIssue);
    video.addEventListener('stalled', onBufferingIssue);

    function onLoaded() {
      video.removeEventListener('loadedmetadata', onLoaded);
      video.removeEventListener('loadeddata', onLoaded);
      video.removeEventListener('canplay', onLoaded);
      video.removeEventListener('canplaythrough', onLoaded);
      if (!isPreviewSlideTarget(state, slideIdx, video, gen)) {
        endPlayAttempt();
        return;
      }
      attemptPlay();
    }

    if (video.readyState >= 2) {
      attemptPlay();
      return;
    }

    if (video.readyState >= 1) {
      attemptPlay();
    }

    video.addEventListener('loadedmetadata', onLoaded, { once: true });
    video.addEventListener('loadeddata', onLoaded, { once: true });
    video.addEventListener('canplay', onLoaded, { once: true });
    video.addEventListener('canplaythrough', onLoaded, { once: true });
  }

  function schedulePreviewWatchdog(state) {
    if (!state) return;
    if (state.previewWatchdog) {
      window.clearTimeout(state.previewWatchdog);
      state.previewWatchdog = null;
    }
    state.previewWatchdog = window.setTimeout(function () {
      state.previewWatchdog = null;
      if (!state || state.destroyed || state.modalOpen || state.dragging || state.inView === false) return;
      var slide = state.slides[state.index];
      if (!slide) return;
      var video = slide.querySelector('.gb-pvs__video');
      if (!video || isVideoActivelyPlaying(video) || video.ended) return;
      var loop = state.root.dataset.videoLoop === 'true';
      state.previewPlayInFlight = false;
      playInlinePreview(state, slide, video, loop);
    }, 1200);
  }

  function syncActivePreviewNow(state) {
    if (!state || state.modalOpen || state.destroyed || state.dragging) return;
    if (state.inView === false) return;
    var loop = state.root.dataset.videoLoop === 'true';
    var active = state.index;
    var activeSlide = state.slides[active];
    var activeVideo = activeSlide ? activeSlide.querySelector('.gb-pvs__video') : null;
    var nextLogical = logicalIndex(state);
    var prevVideo = state.previewVideo;
    var prevLogical = state.previewLogical;

    if (
      prevVideo &&
      activeVideo &&
      prevVideo !== activeVideo &&
      prevLogical === nextLogical &&
      prevVideo.currentTime > 0.15
    ) {
      try {
        activeVideo.currentTime = prevVideo.currentTime;
      } catch (error) {
        /* ignore */
      }
    }

    state.slides.forEach(function (slide, i) {
      var video = slide.querySelector('.gb-pvs__video');
      var card = slide.querySelector('.gb-pvs__card');
      if (!video) return;

      var isActive = i === active;

      if (isActive) {
        configureInlinePreviewVideo(video, loop);
        applyCanonicalInlineSource(slide, state);
        if (!isVideoActivelyPlaying(video)) {
          playInlinePreview(state, slide, video, loop);
        } else {
          state.previewVideo = video;
          state.previewSlideIndex = i;
          syncPreviewPlayingClass(slide, video);
        }
      } else {
        stopVideoPlayback(video);
        // Hux: inaktive Slides laden nichts vor
        video.preload = 'none';
        if (card) card.classList.remove('is-preview-playing');
        syncPreviewPlayingClass(slide, video);
      }
    });

    state.previewLogical = nextLogical;
    prefetchNeighborPreviewVideos(state);
    schedulePreviewWatchdog(state);
  }

  function syncActivePreview(state) {
    if (!state || state.modalOpen || state.destroyed || state.dragging) return;
    syncActivePreviewNow(state);
  }

  function measureSlideWidth(slides, preferredIndex) {
    var width = 0;
    if (slides[preferredIndex]) width = slides[preferredIndex].offsetWidth;
    if (!width && slides[0]) width = slides[0].offsetWidth;
    if (!width) {
      for (var i = 0; i < slides.length; i += 1) {
        if (slides[i].offsetWidth) {
          width = slides[i].offsetWidth;
          break;
        }
      }
    }
    if (!width && slides[0]) {
      var rect = slides[0].getBoundingClientRect();
      if (rect.width) width = rect.width;
    }
    if (!width && slides[0]) {
      var root = slides[0].closest('[data-gb-pvs]');
      if (root && window.getComputedStyle) {
        var slideStyle = window.getComputedStyle(slides[0]);
        var parsed = parseFloat(slideStyle.width, 10);
        if (parsed) width = parsed;
      }
    }
    return width;
  }

  function getPaintMetrics(state) {
    var slides = state.slides;
    var active = state.index;
    var fan = getFanConfig(state.root, state.count);
    var width = measureSlideWidth(slides, active);
    var step = width * fan.gapRatio;
    return { fan: fan, step: step, width: width };
  }

  /** One-card swipe: drag is capped to a single slide step (reference fan carousel). */
  function normalizeDragPx(dragPx, step) {
    if (!step) return 0;
    var max = step;
    var drag = dragPx || 0;
    if (drag > max) {
      return max + (drag - max) * 0.15;
    }
    if (drag < -max) {
      return -max + (drag + max) * 0.15;
    }
    return drag;
  }

  function dragInfluenceForOffset(baseOffset) {
    if (Math.abs(baseOffset) <= 1) return 1;
    return 0;
  }

  function paint(state, dragPx) {
    var slides = state.slides;
    var active = state.index;
    var metrics = getPaintMetrics(state);
    var fan = metrics.fan;
    var step = metrics.step;
    var drag = normalizeDragPx(dragPx, step);
    var wrapper = state.el.querySelector('.swiper-wrapper');

    if (wrapper) {
      wrapper.classList.toggle('is-dragging', !!state.dragging);
    }
    state.el.classList.toggle('is-dragging', !!state.dragging);

    for (var i = 0; i < slides.length; i += 1) {
      var slide = slides[i];
      var baseOffset = i - active;
      var influence = dragInfluenceForOffset(baseOffset);
      var slideDrag = drag * influence;
      var visualOffset = baseOffset + (step ? slideDrag / step : 0);
      var abs = Math.abs(visualOffset);
      var scale = 1 - abs * fan.scaleStep;
      if (scale < 0.58) scale = 0.58;

      var visible = abs <= fan.sideSlides + 0.45;
      var translateX = baseOffset * step + slideDrag;
      slide.style.transform =
        'translateX(-50%) translateX(' + translateX + 'px) scale(' + scale + ')';
      slide.style.zIndex = String(40 - Math.round(abs * 10));
      slide.style.opacity = visible ? '1' : '0';
      slide.style.visibility = visible ? 'visible' : 'hidden';
      slide.style.pointerEvents = visible && !state.dragging ? 'auto' : 'none';

      var isCentered = state.dragging ? abs < 0.5 : baseOffset === 0;
      slide.classList.toggle('is-active', isCentered);
      slide.classList.toggle('swiper-slide-active', isCentered);

      var blurPx = abs < 0.12 ? 0 : Math.min(10, abs * fan.blurStep);
      var inner = slide.querySelector('.swiper-carousel-animate-opacity');
      if (inner) {
        var innerOpacity = 1 - abs * fan.opacityStep;
        if (abs <= fan.sideSlides) innerOpacity = Math.max(0.48, innerOpacity);
        if (innerOpacity < 0) innerOpacity = 0;
        inner.style.opacity = String(innerOpacity);
        inner.style.filter = blurPx ? 'blur(' + blurPx.toFixed(2) + 'px)' : 'none';
      }
    }

    if (!state.dragging) {
      syncPagination(state);
      syncActivePreview(state);
    }
  }

  function finishDrag(state) {
    if (!state || !state.dragging) return;

    var metrics = getPaintMetrics(state);
    var step = metrics.step || 1;
    var dragPx = normalizeDragPx(state.dragPx || 0, step);
    var threshold = Math.min(56, step * 0.18);
    var dir = 0;

    if (Math.abs(dragPx) >= threshold) {
      dir = dragPx < 0 ? 1 : -1;
    }

    state.dragging = false;
    state.pointerTracking = false;
    state.dragPx = 0;
    state.dragPointerId = null;

    if (dir !== 0) {
      goBy(state, dir);
    } else {
      goTo(state, state.index, false);
    }

    if (state.dragDidMove && dir !== 0) {
      state.suppressClick = true;
      window.setTimeout(function () {
        state.suppressClick = false;
      }, 320);
    }

    state.dragDidMove = false;
    startAutoplay(state);
  }

  function slideFromPoint(state, clientX, clientY, eventTarget) {
    if (eventTarget && eventTarget.nodeType === 1) {
      var fromTarget = eventTarget.closest('.swiper-slide');
      if (fromTarget && state.el.contains(fromTarget)) return fromTarget;
    }
    var hit = document.elementFromPoint(clientX, clientY);
    if (!hit) return null;
    var slide = hit.closest('.swiper-slide');
    if (!slide || !state.el.contains(slide)) return null;
    return slide;
  }

  function resolveModalIndex(state, slide, opener) {
    var index = NaN;
    if (opener) index = parseInt(opener.getAttribute('data-index'), 10);
    if (isNaN(index) && slide) index = parseInt(slide.getAttribute('data-gb-pvs-index'), 10);
    if (isNaN(index)) index = logicalIndex(state);
    return index;
  }

  function openModalFromSlide(state, slide) {
    if (!state || !slide || state.modalOpen) return false;
    var opener = slide.querySelector('[data-gb-pvs-open]');
    if (!opener) return false;
    openModal(state, resolveModalIndex(state, slide, opener));
    return true;
  }

  function centerSlide(state, slide) {
    if (!state || !slide) return false;
    var nextIndex = state.slides.indexOf(slide);
    if (nextIndex < 0) return false;
    goTo(state, nextIndex, false);
    window.setTimeout(function () {
      wrapIfNeeded(state, true);
    }, 420);
    return true;
  }

  function suppressClickBriefly(state) {
    state.suppressClick = true;
    window.setTimeout(function () {
      state.suppressClick = false;
    }, 320);
  }

  function activateSlideAtPoint(state, clientX, clientY) {
    if (!state || state.modalOpen) return false;
    var slide = slideFromPoint(state, clientX, clientY, null);
    if (!slide || slide.classList.contains('is-active')) return false;

    if (!centerSlide(state, slide)) return false;
    suppressClickBriefly(state);
    return true;
  }

  function handleSlideTap(state, clientX, clientY, eventTarget) {
    if (!state || state.modalOpen || state.suppressClick) return false;
    var slide = slideFromPoint(state, clientX, clientY, eventTarget);
    if (!slide) return false;
    if (!slide.querySelector('.gb-pvs__card, [data-gb-pvs-open]')) return false;

    if (!slide.classList.contains('is-active')) {
      if (!centerSlide(state, slide)) return false;
      suppressClickBriefly(state);
      return true;
    }

    var opener =
      eventTarget && eventTarget.nodeType === 1
        ? eventTarget.closest('[data-gb-pvs-open]')
        : null;
    if (!opener || !slide.contains(opener)) {
      opener = slide.querySelector('[data-gb-pvs-open]');
    }
    if (!opener) return false;
    openModal(state, resolveModalIndex(state, slide, opener));
    suppressClickBriefly(state);
    return true;
  }

  function bindSwipe(state) {
    if (state.count <= 1) return;

    var dragStartX = 0;
    var dragStartY = 0;
    var dragAxis = null;

    state.onPointerDown = function (event) {
      if (state.modalOpen || state.destroyed) return;
      if (event.button !== undefined && event.button !== 0) return;
      if (event.target.closest('[data-gb-pvs-prev], [data-gb-pvs-next], [data-gb-pvs-pagination]')) return;

      dragAxis = null;
      state.pointerTracking = true;
      state.dragging = false;
      state.dragPx = 0;
      state.dragDidMove = false;
      state.dragPointerId = event.pointerId;
      dragStartX = event.clientX;
      dragStartY = event.clientY;

      if (!event.target.closest('.gb-pvs__play[data-gb-pvs-open]')) {
        try {
          state.el.setPointerCapture(event.pointerId);
        } catch (error) {
          /* ignore */
        }
      }
    };

    state.onPointerMove = function (event) {
      if (!state.pointerTracking || event.pointerId !== state.dragPointerId) return;

      var deltaX = event.clientX - dragStartX;
      var deltaY = event.clientY - dragStartY;

      if (!dragAxis) {
        if (Math.abs(deltaX) < 6 && Math.abs(deltaY) < 6) return;
        dragAxis = Math.abs(deltaX) >= Math.abs(deltaY) ? 'x' : 'y';
      }

      if (dragAxis !== 'x') {
        state.pointerTracking = false;
        state.dragging = false;
        state.dragPx = 0;
        state.dragPointerId = null;
        dragAxis = null;
        return;
      }

      if (event.cancelable) event.preventDefault();

      if (!state.dragging) {
        state.dragging = true;
        stopAutoplay(state);
      }

      var metrics = getPaintMetrics(state);
      state.dragPx = normalizeDragPx(deltaX, metrics.step);
      if (Math.abs(deltaX) > 8) state.dragDidMove = true;
      paint(state, state.dragPx);
    };

    state.onPointerUp = function (event) {
      if (event.pointerId !== state.dragPointerId) return;
      try {
        state.el.releasePointerCapture(event.pointerId);
      } catch (error) {
        /* ignore */
      }

      if (state.dragging) {
        finishDrag(state);
      } else if (state.pointerTracking) {
        handleSlideTap(state, event.clientX, event.clientY, event.target);
        state.pointerTracking = false;
        state.dragPointerId = null;
      }

      dragAxis = null;
    };

    state.onPointerCancel = state.onPointerUp;

    state.el.addEventListener('pointerdown', state.onPointerDown, listenerOpts(state));
    state.el.addEventListener('pointermove', state.onPointerMove, listenerOpts(state, { passive: false }));
    state.el.addEventListener('pointerup', state.onPointerUp, listenerOpts(state));
    state.el.addEventListener('pointercancel', state.onPointerCancel, listenerOpts(state));
  }

  function wrapIfNeeded(state, instant) {
    if (!state.loop) return;
    var count = state.count;
    var index = state.index;
    if (index >= count && index < count * 2) return;

    var target = logicalIndex(state) + count;
    if (target === index) return;
    goTo(state, target, instant !== false);
  }

  function stopAutoplay(state) {
    if (state.timer) {
      window.clearInterval(state.timer);
      state.timer = null;
    }
  }

  function startAutoplay(state) {
    if (!state || state.destroyed || state.modalOpen) return;
    if (state.root.dataset.autoplay !== 'true') return;
    stopAutoplay(state);
    var delay = parseInt(state.root.dataset.autoplayDelay, 10) || 5000;
    state.timer = window.setInterval(function () {
      if (state.modalOpen) return;
      goBy(state, 1);
    }, delay);
  }

  function goTo(state, index, instant) {
    if (!state || state.destroyed || state.modalOpen) return;
    state.index = index;
    state.previewPlayInFlight = false;

    var wrapper = state.el.querySelector('.swiper-wrapper');
    if (instant && wrapper) wrapper.classList.add('is-instant');
    paint(state);

    if (instant && wrapper) {
      window.requestAnimationFrame(function () {
        wrapper.classList.remove('is-instant');
      });
    }
  }

  function goBy(state, dir) {
    if (!state || state.moving || state.modalOpen) return;
    var next = state.index + dir;
    if (!state.loop) {
      if (next < 0 || next >= state.count) return;
      goTo(state, next, false);
      return;
    }

    var last = state.count * 3 - 1;
    if (next < 0) next = state.count * 2 - 1;
    if (next > last) next = state.count;
    goTo(state, next, false);
    window.setTimeout(function () {
      wrapIfNeeded(state, true);
    }, 420);
  }

  function syncSliderToLogicalIndex(state, logicalIdx) {
    if (!state || state.count <= 1) return;
    var idx = logicalIdx;
    if (idx < 0) idx = 0;
    if (idx >= state.count) idx = state.count - 1;
    var target = state.loop ? idx + state.count : idx;
    goTo(state, target, true);
    window.requestAnimationFrame(function () {
      wrapIfNeeded(state, true);
    });
  }

  function syncPagination(state) {
    var pag = state.root.querySelector('[data-gb-pvs-pagination]');
    if (!pag) return;
    var active = logicalIndex(state);
    pag.querySelectorAll('.swiper-pagination-bullet').forEach(function (bullet, index) {
      bullet.classList.toggle('swiper-pagination-bullet-active', index === active);
    });
  }

  function buildPagination(state) {
    var pag = state.root.querySelector('[data-gb-pvs-pagination]');
    if (!pag) return;
    pag.innerHTML = '';
    for (var i = 0; i < state.count; i += 1) {
      var bullet = document.createElement('button');
      bullet.type = 'button';
      bullet.className = 'swiper-pagination-bullet';
      bullet.setAttribute('data-gb-pvs-page', String(i));
      bullet.setAttribute('aria-label', String(i + 1));
      pag.appendChild(bullet);
    }
    pag.addEventListener('click', function (event) {
      var bullet = event.target.closest('.swiper-pagination-bullet');
      if (!bullet) return;
      var index = parseInt(bullet.getAttribute('data-gb-pvs-page'), 10);
      if (isNaN(index)) return;
      var start = state.loop ? state.count : 0;
      goTo(state, start + index, false);
      window.setTimeout(function () {
        wrapIfNeeded(state, true);
      }, 420);
    });
  }

  function lockScroll() {
    document.documentElement.classList.add('gb-pvs-modal-open');
  }

  function unlockScroll() {
    document.documentElement.classList.remove('gb-pvs-modal-open');
  }

  function configurePopupVideoForSound(video) {
    if (!video) return;
    video.removeAttribute('muted');
    video.muted = false;
    video.defaultMuted = false;
    video.volume = 1;
  }

  function pauseModalVideos(state) {
    if (!state.modalVideos) return;
    state.modalVideos.forEach(function (video) {
      stopVideoPlayback(video);
    });
  }

  function unloadModalVideoElement(video) {
    releaseVideoElement(video);
  }

  function ensureModalVideoSource(state, index) {
    var video = state.modalVideos && state.modalVideos[index];
    var item = state.gallery[index];
    if (!video || !item || !item.src) return;

    var pendingSrc = video.getAttribute('data-gb-pvs-src') || item.src;
    var current = video.getAttribute('src') || '';
    if (!current) {
      video.src = pendingSrc;
    }
    video.preload = 'auto';
    video.controls = true;
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
  }

  function syncModalSlideMedia(state, activeIndex) {
    if (!state.modalVideos || !state.gallery.length) return;
    if (activeIndex < 0) activeIndex = 0;
    if (activeIndex >= state.gallery.length) activeIndex = state.gallery.length - 1;

    state.modalVideos.forEach(function (video, i) {
      if (!video) return;
      if (i === activeIndex) {
        ensureModalVideoSource(state, i);
      } else {
        unloadModalVideoElement(video);
      }
    });
  }

  function parkModalClose(state) {
    var modal = state.modal;
    if (!modal) return;
    var viewport = modal.querySelector('[data-gb-pvs-modal-viewport]');
    var closeBtn = modal.querySelector('[data-gb-pvs-modal-close]');
    if (!viewport || !closeBtn) return;
    if (closeBtn.parentElement !== viewport) {
      viewport.insertBefore(closeBtn, viewport.firstChild);
    }
    closeBtn.hidden = true;
    closeBtn.style.position = '';
    closeBtn.style.top = '';
    closeBtn.style.left = '';
    closeBtn.style.right = '';
  }

  function mountModalClose(state, index) {
    var modal = state.modal;
    if (!modal) return;
    var closeBtn = modal.querySelector('[data-gb-pvs-modal-close]');
    var slides = modal.querySelectorAll('[data-gb-pvs-modal-slide]');
    var activeSlide = slides[index];
    if (!closeBtn || !activeSlide) return;

    closeBtn.hidden = false;
    activeSlide.appendChild(closeBtn);
    closeBtn.style.position = 'absolute';
    closeBtn.style.top = '';
    closeBtn.style.left = '';
    closeBtn.style.right = '';
  }

  function layoutModalSlides(state, index) {
    var modal = state.modal;
    if (!modal) return;
    var slides = modal.querySelectorAll('[data-gb-pvs-modal-slide]');
    var count = slides.length;
    if (!count) return;

    var mobileFs = isModalMobile();
    modal.classList.toggle('gb-pvs-modal--mobile-fs', mobileFs);

    // Hux: Positionsanzeige «2 / 5» im mobilen Vollbild, damit klar ist, dass man wischen kann
    var counter = modal.querySelector('.gb-pvs-modal__counter');
    if (!counter && count > 1) {
      counter = document.createElement('div');
      counter.className = 'gb-pvs-modal__counter';
      counter.setAttribute('aria-live', 'polite');
      var dialog = modal.querySelector('.gb-pvs-modal__dialog') || modal;
      dialog.appendChild(counter);
    }
    if (counter) {
      counter.textContent = index + 1 + ' / ' + count;
      counter.hidden = !mobileFs || count < 2;
    }
    var swipeDir = state.modalSwipeDir || 0;
    state.modalSwipeDir = 0;

    slides.forEach(function (slideEl, i) {
      var offset = circularOffset(i, index, count);
      var abs = Math.abs(offset);
      var isActive = offset === 0;

      if (mobileFs) {
        slideEl.classList.remove('gb-pvs-modal__slide--in-next', 'gb-pvs-modal__slide--in-prev');
        if (isActive && swipeDir) {
          void slideEl.offsetWidth;
          slideEl.classList.add(swipeDir > 0 ? 'gb-pvs-modal__slide--in-next' : 'gb-pvs-modal__slide--in-prev');
        }
        slideEl.classList.toggle('is-active', isActive);
        slideEl.classList.toggle('is-adjacent', false);
        slideEl.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        slideEl.style.visibility = isActive ? 'visible' : 'hidden';
        slideEl.style.pointerEvents = isActive ? 'auto' : 'none';
        slideEl.style.zIndex = isActive ? '3' : '1';
        slideEl.style.opacity = isActive ? '1' : '0';
        slideEl.style.filter = 'none';
        slideEl.style.transform = '';
        slideEl.style.width = '';
        slideEl.style.height = '';
        slideEl.style.maxHeight = '';
        return;
      }

      var visible = abs <= 1;
      slideEl.classList.toggle('is-active', isActive);
      slideEl.classList.toggle('is-adjacent', abs === 1);
      slideEl.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      slideEl.style.visibility = visible ? 'visible' : 'hidden';
      slideEl.style.pointerEvents = abs === 1 ? 'auto' : isActive ? 'auto' : 'none';
      slideEl.style.zIndex = isActive ? '5' : abs === 1 ? '3' : '1';
      slideEl.style.width = '';
      slideEl.style.height = '';
      slideEl.style.maxHeight = '';
      var scale = isActive ? 1 : 0.86;
      var shiftVw = offset * 24;
      slideEl.style.opacity = visible ? '1' : '0';
      slideEl.style.filter = 'none';
      slideEl.style.transform =
        'translate(calc(-50% + ' + shiftVw + 'vw), -50%) scale(' + scale + ')';
    });

    var prevBtn = modal.querySelector('[data-gb-pvs-modal-prev]');
    var nextBtn = modal.querySelector('[data-gb-pvs-modal-next]');
    if (prevBtn) prevBtn.disabled = count <= 1;
    if (nextBtn) nextBtn.disabled = count <= 1;

    mountModalClose(state, index);
  }

  function attachModalToBody(state) {
    if (!state.modal) return;
    if (!state.modalMount) {
      state.modalMount = state.modal.parentNode;
      state.modalNextSibling = state.modal.nextSibling;
    }
    if (state.modal.parentNode !== document.body) {
      document.body.appendChild(state.modal);
    }
  }

  function restoreModalPlacement(state) {
    if (!state.modal || !state.modalMount) return;
    if (state.modal.parentNode === document.body) {
      if (state.modalNextSibling) {
        state.modalMount.insertBefore(state.modal, state.modalNextSibling);
      } else {
        state.modalMount.appendChild(state.modal);
      }
    }
  }

  function handleModalBackdropClick(state, event) {
    if (!state.modalOpen || !state.modal) return;

    if (event.target.closest('[data-gb-pvs-modal-close]')) {
      event.preventDefault();
      event.stopPropagation();
      closeModal(state);
      return;
    }
    if (event.target.closest('[data-gb-pvs-modal-sound]')) return;
    if (event.target.closest('[data-gb-pvs-modal-prev]')) return;
    if (event.target.closest('[data-gb-pvs-modal-next]')) return;
    if (event.target.closest('video.gb-pvs-modal__video')) return;

    var adjacent = event.target.closest('.gb-pvs-modal__slide.is-adjacent');
    if (adjacent) {
      event.preventDefault();
      event.stopPropagation();
      var idx = parseInt(adjacent.getAttribute('data-gb-pvs-modal-slide'), 10);
      if (!isNaN(idx)) playModalVideo(state, idx);
      return;
    }

    if (event.target.closest('.gb-pvs-modal__slide.is-active')) return;

    closeModal(state);
  }

  function unmutePopupIfPossible(video, soundBtn) {
    configurePopupVideoForSound(video);
    if (soundBtn) soundBtn.hidden = !video.muted;
  }

  function attemptModalPlayback(state, video, soundBtn) {
    if (!video || !state.modalOpen) return;
    if (isVideoActivelyPlaying(video)) {
      unmutePopupIfPossible(video, soundBtn);
      return;
    }

    state.modalPlayGen = (state.modalPlayGen || 0) + 1;
    var gen = state.modalPlayGen;

    video.loop = false;
    video.controls = true;
    video.preload = 'auto';
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.muted = true;
    video.defaultMuted = true;
    video.setAttribute('muted', '');
    if (soundBtn) soundBtn.hidden = true;

    function stillValid() {
      return (
        state.modalPlayGen === gen &&
        state.modalOpen &&
        state.modalVideos[state.modalIndex] === video
      );
    }

    function afterPlaying() {
      if (!stillValid()) return;
      video.autoplay = false;
      video.removeAttribute('autoplay');
      unmutePopupIfPossible(video, soundBtn);
    }

    function tryPlay() {
      if (!stillValid()) return;
      if (isVideoActivelyPlaying(video)) {
        afterPlaying();
        return;
      }

      video.muted = true;
      video.defaultMuted = true;
      video.setAttribute('muted', '');
      video.autoplay = true;
      video.setAttribute('autoplay', '');

      var playPromise;
      try {
        playPromise = video.play();
      } catch (error) {
        if (soundBtn) soundBtn.hidden = false;
        return;
      }

      if (playPromise && typeof playPromise.then === 'function') {
        playPromise
          .then(function () {
            afterPlaying();
          })
          .catch(function () {
            if (!stillValid()) return;
            video.muted = true;
            video.defaultMuted = true;
            video.setAttribute('muted', '');
            var mutedPlay = video.play();
            if (mutedPlay && typeof mutedPlay.then === 'function') {
              mutedPlay.then(afterPlaying).catch(function () {
                if (!stillValid()) return;
                if (soundBtn) soundBtn.hidden = false;
              });
            }
          });
      }
    }

    tryPlay();
    video.addEventListener('playing', afterPlaying, { once: true });
    if (!isVideoActivelyPlaying(video)) {
      video.addEventListener('canplay', tryPlay, { once: true });
    }
  }

  function playModalVideo(state, index) {
    if (!state.gallery.length) return;
    if (index < 0) index = 0;
    if (index >= state.gallery.length) index = state.gallery.length - 1;

    var sameClip =
      state.modalOpen &&
      state.modalIndex === index &&
      state.modalVideos &&
      isVideoActivelyPlaying(state.modalVideos[index]);

    state.modalIndex = index;
    pauseInlineVideos(state.root);
    layoutModalSlides(state, index);
    syncModalSlideMedia(state, index);

    var video = state.modalVideos[index];
    var soundBtn = state.modal.querySelector('[data-gb-pvs-modal-sound]');
    if (!video) return;

    video.loop = false;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.controls = true;

    if (sameClip) {
      unmutePopupIfPossible(video, soundBtn);
      return;
    }

    void video.offsetHeight;
    attemptModalPlayback(state, video, soundBtn);
  }

  function rebuildModalVideos(state) {
    var viewport = state.modal.querySelector('[data-gb-pvs-modal-viewport]');
    if (!viewport) return;
    parkModalClose(state);
    viewport.querySelectorAll('video').forEach(function (video) {
      releaseVideoElement(video);
    });
    viewport.querySelectorAll('[data-gb-pvs-modal-slide]').forEach(function (slide) {
      slide.remove();
    });
    state.modalVideos = [];

    state.gallery.forEach(function (item, index) {
      var slideEl = document.createElement('div');
      slideEl.className = 'gb-pvs-modal__slide';
      slideEl.setAttribute('data-gb-pvs-modal-slide', String(index));

      if (item.poster) {
        var posterImg = document.createElement('img');
        posterImg.className = 'gb-pvs-modal__poster';
        posterImg.src = item.poster;
        posterImg.alt = '';
        posterImg.setAttribute('loading', 'lazy');
        posterImg.setAttribute('decoding', 'async');
        slideEl.appendChild(posterImg);
      }

      var video = document.createElement('video');
      video.className = 'gb-pvs-modal__video';
      video.setAttribute('preload', 'none');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.setAttribute('data-gb-pvs-src', item.hls && canPlayHls() ? pickHlsUrl(item.hls, modalHlsMinShort()) : item.src);
      video.autoplay = false;
      video.removeAttribute('autoplay');
      video.loop = false;
      video.controls = false;
      if (item.poster) video.setAttribute('poster', item.poster);

      slideEl.appendChild(video);
      viewport.appendChild(slideEl);
      state.modalVideos.push(video);
    });
  }

  function finalizeModalClose(state) {
    if (!state) return;
    state.modalClosing = false;
    if (state.modalCloseTimer) {
      window.clearTimeout(state.modalCloseTimer);
      state.modalCloseTimer = null;
    }

    if (state.modal) {
      state.modal.hidden = true;
      state.modal.setAttribute('aria-hidden', 'true');
      state.modal.classList.remove('gb-pvs-modal--visible');
      var soundBtn = state.modal.querySelector('[data-gb-pvs-modal-sound]');
      if (soundBtn) soundBtn.hidden = true;
      state.modal.classList.remove('gb-pvs-modal--mobile-fs');
      parkModalClose(state);
      restoreModalPlacement(state);
    }

    unlockScroll();

    if (typeof state.modalIndex === 'number') {
      syncSliderToLogicalIndex(state, state.modalIndex);
    }
    state.root.querySelectorAll('.gb-pvs__video').forEach(function (video) {
      video.muted = true;
      video.defaultMuted = true;
      video.setAttribute('muted', '');
    });

    startAutoplay(state);
    syncActivePreview(state);

    if (state.lastFocus && typeof state.lastFocus.focus === 'function') {
      state.lastFocus.focus();
    }
  }

  function openModal(state, startIndex) {
    if (!state.gallery.length || state.destroyed) return;
    if (state.modalOpen) {
      playModalVideo(state, startIndex);
      return;
    }
    if (state.modalCloseTimer) {
      window.clearTimeout(state.modalCloseTimer);
      state.modalCloseTimer = null;
    }
    state.modalClosing = false;
    state.modalOpen = true;
    state.lastFocus = document.activeElement;
    state.previewPlayGen += 1;

    stopAutoplay(state);
    attachModalToBody(state);
    rebuildModalVideos(state);
    state.modal.hidden = false;
    state.modal.setAttribute('aria-hidden', 'false');
    lockScroll();
    pauseInlineVideos(state.root);
    void state.modal.offsetHeight;
    state.modal.classList.add('gb-pvs-modal--visible');

    playModalVideo(state, startIndex);

    if (state.modalKeyHandler) {
      document.removeEventListener('keydown', state.modalKeyHandler);
    }
    state.modalKeyHandler = function (event) {
      if (!state.modalOpen) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        closeModal(state);
        return;
      }
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        goModalBy(state, -1);
        return;
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        goModalBy(state, 1);
      }
    };
    document.addEventListener('keydown', state.modalKeyHandler);

    if (state.modalResizeHandler) {
      window.removeEventListener('resize', state.modalResizeHandler);
    }
    state.modalResizeHandler = function () {
      if (!state.modalOpen) return;
      layoutModalSlides(state, state.modalIndex);
      syncModalSlideMedia(state, state.modalIndex);
    };
    window.addEventListener('resize', state.modalResizeHandler);

    var closeBtn = state.modal.querySelector('.gb-pvs-modal__close');
    if (closeBtn) {
      window.setTimeout(function () {
        if (state.modalOpen && closeBtn.isConnected) closeBtn.focus();
      }, MODAL_TRANSITION_MS);
    }
  }

  function goModalBy(state, dir) {
    if (!state.gallery.length) return;
    var next = state.modalIndex + dir;
    if (next < 0) next = state.gallery.length - 1;
    if (next >= state.gallery.length) next = 0;
    playModalVideo(state, next);
  }

  function closeModal(state, force) {
    if (!state) return;
    if (!force && !state.modalOpen) return;
    if (!force && state.modalClosing) return;

    state.modalOpen = false;
    state.modalPlayGen = (state.modalPlayGen || 0) + 1;
    pauseModalVideos(state);
    if (state.modalVideos) {
      state.modalVideos.forEach(function (video) {
        unloadModalVideoElement(video);
      });
    }

    if (state.modalKeyHandler) {
      document.removeEventListener('keydown', state.modalKeyHandler);
      state.modalKeyHandler = null;
    }
    if (state.modalResizeHandler) {
      window.removeEventListener('resize', state.modalResizeHandler);
      state.modalResizeHandler = null;
    }

    if (!state.modal) {
      finalizeModalClose(state);
      return;
    }

    if (force) {
      finalizeModalClose(state);
      return;
    }

    state.modal.classList.remove('gb-pvs-modal--visible');
    state.modalClosing = true;
    state.modalCloseTimer = window.setTimeout(function () {
      state.modalCloseTimer = null;
      finalizeModalClose(state);
    }, MODAL_TRANSITION_MS);
  }

  function listenerOpts(state, extra) {
    var opts = extra ? Object.assign({}, extra) : {};
    if (state.abortController) opts.signal = state.abortController.signal;
    return opts;
  }

  function bindModal(state) {
    state.modal = state.root.querySelector('[data-gb-pvs-modal]');
    if (!state.modal) return;

    state.modalBackdropHandler = function (event) {
      handleModalBackdropClick(state, event);
    };
    state.modal.addEventListener('click', state.modalBackdropHandler, listenerOpts(state));

    // Hux: Im mobilen Vollbild per Wischen zum nächsten/vorherigen Video, nach unten wischen schliesst
    var swipe = null;
    state.modal.addEventListener(
      'touchstart',
      function (event) {
        if (!state.modalOpen || !isModalMobile() || event.touches.length !== 1) {
          swipe = null;
          return;
        }
        var t = event.touches[0];
        swipe = { x: t.clientX, y: t.clientY, time: Date.now() };
      },
      listenerOpts(state, { passive: true })
    );
    state.modal.addEventListener(
      'touchend',
      function (event) {
        if (!swipe || !state.modalOpen) return;
        var t = event.changedTouches && event.changedTouches[0];
        var start = swipe;
        swipe = null;
        if (!t) return;
        var dx = t.clientX - start.x;
        var dy = t.clientY - start.y;
        if (Date.now() - start.time > 900) return;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.4) {
          if (state.gallery.length < 2) return;
          state.modalSwipeDir = dx < 0 ? 1 : -1;
          goModalBy(state, state.modalSwipeDir);
          return;
        }
        if (dy > 110 && Math.abs(dy) > Math.abs(dx) * 1.6) {
          closeModal(state);
        }
      },
      listenerOpts(state, { passive: true })
    );
    state.modal.addEventListener(
      'touchcancel',
      function () {
        swipe = null;
      },
      listenerOpts(state, { passive: true })
    );

    var prev = state.modal.querySelector('[data-gb-pvs-modal-prev]');
    var next = state.modal.querySelector('[data-gb-pvs-modal-next]');
    var sound = state.modal.querySelector('[data-gb-pvs-modal-sound]');

    if (prev) {
      prev.addEventListener(
        'click',
        function (event) {
          event.preventDefault();
          goModalBy(state, -1);
        },
        listenerOpts(state)
      );
    }
    if (next) {
      next.addEventListener(
        'click',
        function (event) {
          event.preventDefault();
          goModalBy(state, 1);
        },
        listenerOpts(state)
      );
    }
    if (sound) {
      sound.addEventListener(
        'click',
        function (event) {
          event.preventDefault();
          var video = state.modalVideos[state.modalIndex];
          if (!video) return;
          if (isVideoActivelyPlaying(video)) {
            configurePopupVideoForSound(video);
            sound.hidden = true;
            return;
          }
          attemptModalPlayback(state, video, sound);
        },
        listenerOpts(state)
      );
    }
  }

  function bindOpenHandlers(state) {
    state.root.addEventListener('click', function (event) {
      if (state.suppressClick) return;
      if (event.target.closest('[data-gb-pvs-prev], [data-gb-pvs-next], [data-gb-pvs-pagination]')) return;

      var opener = event.target.closest('[data-gb-pvs-open]');
      var slide = slideFromPoint(state, event.clientX, event.clientY, event.target);

      if (!slide) {
        if (!opener || !state.root.contains(opener)) return;
        slide = opener.closest('.swiper-slide');
      }

      if (!slide || !state.el.contains(slide)) return;
      if (!opener) opener = slide.querySelector('[data-gb-pvs-open]');
      if (!opener) return;

      var inCard =
        event.target.closest('[data-gb-pvs-open]') ||
        event.target.closest('.swiper-carousel-animate-opacity');
      if (!inCard) return;

      event.preventDefault();
      event.stopPropagation();

      if (!slide.classList.contains('is-active')) {
        centerSlide(state, slide);
        return;
      }

      openModal(state, resolveModalIndex(state, slide, opener));
    }, listenerOpts(state));
  }

  function bindVisibilityObserver(state) {
    if (!state || !state.root) return;

    if (!('IntersectionObserver' in window)) {
      state.inView = true;
      return;
    }

    var SHOW_MS = 120;
    var HIDE_MS = 420;

    if (state.visibilityObserver) {
      state.visibilityObserver.disconnect();
      state.visibilityObserver = null;
    }
    if (state.visibilityDebounce) {
      window.clearTimeout(state.visibilityDebounce);
      state.visibilityDebounce = null;
    }
    state.ioLastEntry = null;

    state.visibilityObserver = new IntersectionObserver(
      function (entries) {
        var entry = entries[0];
        if (!entry) return;
        if (entry.boundingClientRect && entry.boundingClientRect.height < 2) {
          return;
        }
        state.ioLastEntry = entry;

        if (state.visibilityDebounce) {
          window.clearTimeout(state.visibilityDebounce);
          state.visibilityDebounce = null;
        }

        if (entry.isIntersecting) {
          state.visibilityDebounce = window.setTimeout(function () {
            state.visibilityDebounce = null;
            if (state.destroyed) return;
            if (!state.ioLastEntry || !state.ioLastEntry.isIntersecting) return;

            var wasVisible = state.inView !== false;
            state.inView = true;
            state.previewPlayInFlight = false;
            if (!wasVisible || !isVideoActivelyPlaying(state.previewVideo)) {
              syncActivePreview(state);
            }
          }, SHOW_MS);
          return;
        }

        state.visibilityDebounce = window.setTimeout(function () {
          state.visibilityDebounce = null;
          if (state.destroyed) return;
          if (state.ioLastEntry && state.ioLastEntry.isIntersecting) return;

          state.inView = false;
          state.previewPlayGen += 1;
          state.previewPlayInFlight = false;
          pauseInlineVideos(state.root);
        }, HIDE_MS);
      },
      { root: null, threshold: [0, 0.05, 0.15], rootMargin: '140px 0px 140px 0px' }
    );
    state.visibilityObserver.observe(state.root);
  }

  function bindUi(state) {
    var root = state.root;
    var prev = root.querySelector('[data-gb-pvs-prev]');
    var next = root.querySelector('[data-gb-pvs-next]');

    if (prev) {
      prev.addEventListener(
        'click',
        function (event) {
          event.preventDefault();
          goBy(state, -1);
        },
        listenerOpts(state)
      );
    }
    if (next) {
      next.addEventListener(
        'click',
        function (event) {
          event.preventDefault();
          goBy(state, 1);
        },
        listenerOpts(state)
      );
    }

    state.el.addEventListener('click', function (event) {
      if (state.suppressClick) {
        event.preventDefault();
        event.stopPropagation();
        return;
      }
      if (event.target.closest('[data-gb-pvs-open], .swiper-carousel-animate-opacity')) return;
      var slide = event.target.closest('.swiper-slide');
      if (!slide || !state.el.contains(slide) || slide.classList.contains('is-active')) return;
      centerSlide(state, slide);
    }, listenerOpts(state));

    bindSwipe(state);

    window.addEventListener('resize', state.onResize, listenerOpts(state));
  }

  function destroySlider(root) {
    var state = root._gbPvsState;
    if (state) {
      state.destroyed = true;
      state.previewPlayInFlight = false;
      state.previewPlayGen += 1;
      state.modalPlayGen = (state.modalPlayGen || 0) + 1;
      stopAutoplay(state);
      closeModal(state, true);
      if (state.abortController) {
        try {
          state.abortController.abort();
        } catch (error) {
          /* ignore */
        }
      }
      if (state.onResize) window.removeEventListener('resize', state.onResize);
      if (state.visibilityObserver) {
        state.visibilityObserver.disconnect();
        state.visibilityObserver = null;
      }
      if (state.visibilityDebounce) {
        window.clearTimeout(state.visibilityDebounce);
        state.visibilityDebounce = null;
      }
      if (state.previewSyncRaf) {
        window.cancelAnimationFrame(state.previewSyncRaf);
        state.previewSyncRaf = null;
      }
      if (state.previewWatchdog) {
        window.clearTimeout(state.previewWatchdog);
        state.previewWatchdog = null;
      }
      pauseInlineVideos(root);
    }
    root._gbPvsState = null;

    var el = root.querySelector('[data-gb-pvs-swiper]');
    if (el) stripLoopCopies(el);

    root.classList.remove('gb-pvs--carousel', 'gb-pvs--single', 'gb-pvs--loop');
    delete root.dataset.gbPvsReady;
  }

  function initSlider(root) {
    if (!root) return;
    destroySlider(root);

    var el = root.querySelector('[data-gb-pvs-swiper]');
    if (!el) return;

    stripLoopCopies(el);

    var gallery = parseGallery(root);
    var originals = [];
    getSlides(el).forEach(function (slide) {
      if (!slide.querySelector('.gb-pvs__video')) {
        slide.remove();
        return;
      }
      originals.push(slide);
    });

    var count = originals.length;
    if (count < 1) return;

    originals.forEach(function (slide, index) {
      slide.dataset.gbPvsOriginal = 'true';
      slide.dataset.gbPvsIndex = String(index);
    });

    root.dataset.videoCount = String(count);

    var state = {
      root: root,
      el: el,
      slides: originals,
      count: count,
      index: 0,
      loop: false,
      gallery: gallery,
      modal: null,
      modalVideos: [],
      modalIndex: 0,
      modalOpen: false,
      modalKeyHandler: null,
      modalResizeHandler: null,
      lastFocus: null,
      destroyed: false,
      timer: null,
      dragging: false,
      pointerTracking: false,
      dragPx: 0,
      dragPointerId: null,
      dragDidMove: false,
      suppressClick: false,
      // Hux: startet unsichtbar; der IntersectionObserver schaltet die Vorschau ein
      inView: !('IntersectionObserver' in window),
      previewSyncRaf: null,
      previewPlayGen: 0,
      modalPlayGen: 0,
      abortController: typeof AbortController === 'function' ? new AbortController() : null
    };

    // Hux: HLS-Variantenlisten (je < 1 KB) früh laden, damit Vorschau und Popup direkt die passende Qualität nutzen
    preloadHlsVariants(root);
    bindModal(state);
    bindOpenHandlers(state);
    originals.forEach(function (slide) {
      hydrateSlide(slide, null, state);
    });

    if (count === 1) {
      root.classList.add('gb-pvs--single');
      originals[0].classList.add('is-active', 'swiper-slide-active');
      root._gbPvsState = state;
      pauseInlineVideos(root);
      primeActiveSlideVideo(state);
      syncActivePreviewNow(state);
      bindVisibilityObserver(state);
      root.dataset.gbPvsReady = 'true';
      return;
    }

    var loop = root.dataset.loop === 'true';
    if (loop) seedSeamlessLoop(el, originals, state);

    root.classList.add('gb-pvs--carousel');
    if (loop) root.classList.add('gb-pvs--loop');

    state.slides = getSlides(el);
    state.index = loop ? count : 0;
    state.loop = loop;

    state.onResize = function () {
      paint(state);
    };

    root._gbPvsState = state;
    bindUi(state);
    if (root.dataset.showPagination === 'true') buildPagination(state);

    root.dataset.gbPvsReady = 'true';
    pauseInlineVideos(root);
    paint(state);
    primeActiveSlideVideo(state);
    syncActivePreviewNow(state);
    window.requestAnimationFrame(function () {
      if (state.destroyed) return;
      paint(state);
      wrapIfNeeded(state, true);
      startAutoplay(state);
      bindVisibilityObserver(state);
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-gb-pvs]').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-gb-pvs]').forEach(initSlider);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-gb-pvs]').forEach(destroySlider);
  });
})();
